import React, { useState, useEffect } from 'react';
import NextLink from 'next/link'
import { Text, Link } from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons'

export default function ExternalLink(props) {
    const [fontSize, setFontSize] = useState(props.fontSize ? props.fontSize: 'md')
    // console.log(props.link);

    return (
    <>
    <Text fontSize={fontSize} fontWeight="medium" color={'cyan.400'}>
        <Link href={props.link} isExternal>{props.linktext}</Link><ExternalLinkIcon mx="2px" />
    </Text>
    </>
    )
}